import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import { ReportTags } from "./ReportTags";
import type { EstoreReportRowDto } from "@/api/dtos";
import type { EstoreReportRow } from "./_models/EstoreReport";
import { toEstoreReportRowFromDto } from "./_transformers/toEstoreReportRowFromDto";

/** The merged eStore export (GET /sandbox/estore-report) built by process-estore: { total, rows }. */
export const getEstoreReportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getEstoreReport: builder.query<EstoreReportRow[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<{ total: number; rows: EstoreReportRowDto[] }>(
            `${backendBase()}/sandbox/estore-report`,
            { headers: { Accept: "application/json" } },
          );
          const rows = res.data.rows.map((x) => toEstoreReportRowFromDto(x));
          return { data: rows };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
      providesTags: [{ type: ReportTags.EstoreReport, id: "LIST" }],
    }),
  }),
});

export const getEstoreReport = getEstoreReportApi.endpoints.getEstoreReport;
